module.exports = __webpack_public_path__ + "img/position_CB.44ee161f.png";